import { useMutation } from '@tanstack/react-query';
import fileDownload from 'react-file-download';

import { downloadTourOptionPriceHistory } from '~/services/ToursService';

/** Downloads every price change on a legacy tour option, as a CSV. */
export function useDownloadTourOptionPriceHistory() {
  return useMutation({
    mutationFn: async ({ tourOptionId, name }: { tourOptionId: string; name: string }) => {
      const csv = await downloadTourOptionPriceHistory(tourOptionId);
      fileDownload(csv, `prices-tour-option-${name}.csv`);
    },
  });
}
